import {
	IRPCPublishment
} from '@staffbar/types';

export class RPCPublishment implements IRPCPublishment {
	
  constructor({ publishmentName, message }: { publishmentName: string, message: string }) {
    this.publishmentName = publishmentName;
    this.message = message;
  }

  public publishmentName: string;
  public message: any;
}
